// TODO: we should update script and fragment in public/sfdc-form.html when the form is ready
// This component will render an iframe containing the Salesforce form
// The form is hosted in public/sfdc-form.html
// This approach avoids issues with Remix and Salesforce scripts conflicting
// and allows the Salesforce form to be loaded in an isolated environment
export default function NewsletterForm() {
  // Disable scrolling within the iframe,
  // https://github.com/davidjbradshaw/iframe-resizer/issues/1142#issuecomment-1959544213
  return (
    <>
      <h5 className="mb-10">
        Be the first to know what we're doing - and how you can get more
        involved.
      </h5>
      <iframe
        src="/sfdc-form.html"
        title="Newsletter Signup"
        className="my-10 w-full"
        style={{ height: "400px" }}
        sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation-by-user-activation"
        scrolling="no"
      />
    </>
  );
}
